import React,{useState, useEffect} from 'react';
import {Box, CircularProgress} from '@mui/material';
import BtnPrimary from '../PrimaryButton';
import FormField from '../Formfield';
import MainBox from "../../app/main/container/MainBox";
import TypeBtn from '../AddRemoveButton';
import { findDepartment } from '../../utils/findDepartment';
import CheckboxField from '../CheckboxField';
import {getEmployeeListFromGroups, getEmployeeListFromDepartments} from '../../utils/getEmployeeList';
import { useNavigate } from 'react-router';
import { linkPolicy} from '../../services/expense';
import { findGroup } from '../../utils/findGroup';
import { addDepartmentsToLeavePolicy, addGroupsToLeavePolicy } from '../../services/leave';
import ErrorMsg from '../ErrorMsg';
import { updateShift } from '../../services/shift';
import { updateShiftRotation } from '../../services/shiftRotation';
import SuccessDialog from '../SuccessDialog';
import { updateAttendancePolicy } from '../../services/attendancePolicy';
import { useNotify } from '../NotificationProvider';

import { tokens } from "../../theme";
const ReviewSortBy = ({loadNextPage, sortBy, selectedList, policyId, rulesPageLink, type}) => {

    const notify = useNotify();
    const [apiCall,setApiCall]=useState(false);
    const navigate = useNavigate();
    const [error,setError] = useState("");
    const [list,setList]=useState();
    const [selectedPolicyBearers,setSelectedPolicyBearer] = useState([]);
    const [isSuccessDialogOpen,setIsSuccessDialogOpen] = useState(false);

    useEffect(()=>{
       if(sortBy==="Departments"){
        setList(selectedList.department?.map((item)=>findDepartment(item)));
        setSelectedPolicyBearer(getEmployeeListFromDepartments(selectedList.department));
       }else{
        setList(selectedList.employeeGroup?.map((item)=>findGroup(item)));
        setSelectedPolicyBearer(getEmployeeListFromGroups(selectedList.employeeGroup));
       }    
    },[])

    const handleAdd = () =>{
         loadNextPage("selectSortBy");
    }

    const handleNextClick = async () => {
          setApiCall(true);
          try {
            if(type==="leave"){
              const result = await addDepartmentsToLeavePolicy(policyId,{departments:selectedList?.department});
              const result2 = await addGroupsToLeavePolicy(policyId,{groups:selectedList?.employeeGroup});
              if(result.success && result2.success){
                navigate(rulesPageLink,{state:{policyId:policyId}});
              }else{
                setError(result.message);
                notify.error(result?.message || result2?.message || "Could not assign policy");
              }
            }else if(type==="shift"){
              const result = await updateShift(policyId, {
                employeeGroup: selectedList?.employeeGroup,
                department: selectedList?.department
              });
              if(result.success){
                setIsSuccessDialogOpen(true);
              }else{
                setError(result.message);
                notify.error(result?.message || "Could not assign shift");
              }
            }else if(type==="shift-rotation"){
              const result = await updateShiftRotation(policyId, {
                employeeGroup: selectedList?.employeeGroup,
                department: selectedList?.department
              });
              if(result.success){
                setIsSuccessDialogOpen(true);
              }else{
                setError(result.message);
                notify.error(result?.message || "Could not assign shift rotation");
              }
            }else if(type==="attendance"){
              const result = await updateAttendancePolicy(policyId, {
                employeeGroup: selectedList?.employeeGroup,
                department: selectedList?.department
              });
              if(result.success){
                navigate(rulesPageLink,{state:{policyId:policyId}});
              }else{
                setError(result.message);
                notify.error(result?.message || "Could not assign policy");
              }
            }else{
              const result = await linkPolicy(policyId, { linkTo: selectedList });
              if(result.success){
                navigate(rulesPageLink,{state:{policyId:policyId}});
              }else{
                const message = result.message==="Duplicate policy cateogary"?
                          "Duplicate policy category":result.message;
                setError(message);
                notify.error(message || "Could not assign policy");
              }
            }
          } catch (error) {
            notify.error(error?.message || "Something went wrong assigning the policy");
          } finally {
            setApiCall(false);
          }
    };

    return (
      <Box>
          <Box sx={{ width: "100%", display: "flex", gap: "1.5rem" }}>
                        <FormField
                            label={sortBy+":"}
                            type="text"
                            value={list?.map(obj => obj?.name).join(', ')}
                            disabled={true}
                        />
                        <TypeBtn type="add" onClick={handleAdd}>
                            Add
                        </TypeBtn>
           </Box>
           <Box sx={{
                     fontSize: '1rem',
                     lineHeight: '1.5rem',
                     color: tokens.textMuted,
                     marginBottom: '4px'
                    }}>
                No. of employees selected : {selectedPolicyBearers?.length}
            </Box>
           <MainBox sx={{padding: "2rem"}}>
                <Box sx={{display:"flex", gap: "1.25rem", flexWrap:"wrap"}}>
                          {selectedPolicyBearers?.map((item)=>(
                            <Box sx={{backgroundColor: '#F5E9E1',  borderRadius:"6px",padding: "4px", width:"10rem", height:"2rem",
                                textAlign:"center", fontWeight:"600", fontSize: '0.875rem', 
                                lineHeight: '1.125rem', color:"#2A1D2280", letterSpacing:"-2.5%",
                                display:"flex", alignItems:"center"
                              }}>
                                <CheckboxField
                                    checked={true}
                                    disabled={true}
                                />
                                {item.fname+" "+item.lname}
                            </Box>
                          ))}
                </Box>
           </MainBox>
           <ErrorMsg>{error}</ErrorMsg>
           <Box sx={{display:"flex", justifyContent:"end", gap: "1rem", marginTop: "3rem"}}>
                    <BtnPrimary 
                      onClick={handleNextClick} 
                      sx={{width:"11.875rem", height:"3.125rem", borderRadius:"10px"}}
                      disabled={apiCall}
                    >
                        {apiCall?<CircularProgress/>:"Save and Apply"}
                    </BtnPrimary>
            </Box>
            <SuccessDialog
              open={isSuccessDialogOpen}
              onClose={()=>setIsSuccessDialogOpen(false)}
              message={type==="shift-rotation" ? `Shift rotation created successfully!` : `Shift created successfully!`}
              addNewLink={type==="shift-rotation" ? "/app/shift-rotation/new/rotation-details" : "/app/shift/new/details"}
              addNewText={type==="shift-rotation" ? "Create New Rotation" : "Create New Shift"}
              viewAllLink={type==="shift-rotation" ? "/app/shift-rotation/listing" : "/app/shift/listing"}
              viewAllText={type==="shift-rotation" ? "View All Rotations" : "View All Shifts"}
            />
      </Box>
    )
}

export default ReviewSortBy